import axios from 'axios';
import { main_server_ip } from '../../communication_ips';
import {
    clearAdminSession,
    isRefreshRejected,
    refreshAdminAccessToken,
    refresh_check,
    refresh_error_handle,
} from './refresh_check';

const RefreshCheckApi = axios.create({
    baseURL: main_server_ip,
    timeout: 50000,
    params: {},
});

RefreshCheckApi.interceptors.request.use(refresh_check, refresh_error_handle);

export const createUnauthorizedRetryHandler = (client) => async (error) => {
    const request = error?.config;
    if (error?.response?.status !== 401 || !request || request.__adminRefreshRetried) {
        return Promise.reject(error);
    }

    request.__adminRefreshRetried = true;
    try {
        const accessToken = await refreshAdminAccessToken();
        request.headers = request.headers || {};
        request.headers.Authorization = `Bearer ${accessToken}`;
        return client.request(request);
    } catch (refreshError) {
        if (refreshError.sessionRejected || isRefreshRejected(refreshError)) clearAdminSession();
        return Promise.reject(refreshError);
    }
};

RefreshCheckApi.interceptors.response.use(
    (response) => response,
    createUnauthorizedRetryHandler(RefreshCheckApi),
);

export default RefreshCheckApi;
